const Spinner = ({
	size,
	padding,
	isBlack = false,
	className,
}: { size: number; padding?: string | number, isBlack?: boolean, className?: string }) => {
	return (
		<div style={{ width: size, height: size, padding }} className={className}>
			<span className={`loader ${isBlack ? "black" : ""}`} />
		</div>
	);
};

export default Spinner;
